"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServerClaimer = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var types_1 = require("../claimer/types");
var _launchpadConstants_1 = require("../launchpadConstants");
var _shared_1 = require("../shared");
var utils_1 = require("../shared/utils");
function useServerClaimer(_a) {
    var token = _a.token, distribution = _a.distribution, saleAddress = _a.saleAddress, userTotal = _a.userTotal, getEndpointUrl = _a.getEndpointUrl;
    var account = (0, _shared_1.useUser)().account;
    var _b = (0, react_1.useState)([]), claims = _b[0], setClaims = _b[1];
    var _c = (0, react_1.useState)(), isClaiming = _c[0], setIsClaiming = _c[1];
    var _d = (0, react_1.useState)(false), loaded = _d[0], setLoaded = _d[1];
    var _e = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), userTotalClaimed = _e[0], setUserTotalClaimed = _e[1];
    (0, react_1.useEffect)(function () {
        if (!account || !saleAddress) {
            return;
        }
        if (userTotal.eqn(0)) {
            var emptyClaims = Object.entries(distribution.schedule).map(function (_a, idx) {
                var time = _a[0], percent = _a[1];
                return {
                    idx: idx,
                    time: Math.round(Date.parse(time) / 1000),
                    percent: percent,
                    amount: _launchpadConstants_1.ZERO_BN,
                    isClaimable: false,
                    claimedAmount: _launchpadConstants_1.ZERO_BN,
                };
            });
            setClaims(emptyClaims);
            setLoaded(true);
            return;
        }
        axios_1.default
            .get(getEndpointUrl({ account: account, saleAddress: saleAddress, claimIdx: undefined }))
            .then(function (_a) {
            var data = _a.data;
            var userTotalClaimed = _launchpadConstants_1.ZERO_BN;
            var ongoingClaimIdx = undefined;
            var transformed = data.claims.map(function (dbClaim) {
                var _a = Object.entries(distribution.schedule)[dbClaim.claimIdx], time = _a[0], percent = _a[1];
                var claimedAmount = dbClaim.status === 'success'
                    ? (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(dbClaim.amount), token.decimals)
                    : _launchpadConstants_1.ZERO_BN;
                userTotalClaimed = userTotalClaimed.add(claimedAmount);
                if (dbClaim.status === types_1.DBClaimStatus.ongoing) {
                    ongoingClaimIdx = dbClaim.claimIdx;
                }
                return {
                    idx: dbClaim.claimIdx,
                    time: Math.round(Date.parse(time) / 1000),
                    percent: percent,
                    amount: (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(dbClaim.amount), token.decimals),
                    isClaimable: Date.now() > Date.parse(time),
                    claimedAmount: claimedAmount,
                    tx: dbClaim.tx,
                };
            });
            setClaims(transformed);
            setUserTotalClaimed(userTotalClaimed);
            setLoaded(true);
            setIsClaiming(ongoingClaimIdx);
        })
            .catch(function () { });
    }, [account, distribution.schedule, saleAddress, userTotal.toString()]);
    function claimTokens(claimIdx) {
        setIsClaiming(claimIdx);
        return axios_1.default
            .post(getEndpointUrl({ account: account, saleAddress: saleAddress, claimIdx: claimIdx }))
            .then(function (_a) {
            var claimed = _a.data.claimed;
            if (claimed.status === types_1.DBClaimStatus.fail) {
                return { error: "Failed to claim. TX: ".concat(claimed.tx) };
            }
            if (claimed.status === types_1.DBClaimStatus.success) {
                var updatedClaims = claims.map(function (c) {
                    return c.idx === claimIdx ? __assign(__assign({}, c), { claimedAmount: c.amount }) : c;
                });
                setClaims(updatedClaims);
                return { message: "Claimed! TX: ".concat(claimed.tx) };
            }
        })
            .catch(function (e) {
            return { error: "Failed to claim" };
        })
            .finally(function () { return setIsClaiming(undefined); });
    }
    return {
        symbol: distribution.symbol || token.symbol,
        claimAll: undefined,
        totalClaimed: _launchpadConstants_1.ZERO_BN,
        claimTokens: claimTokens,
        userTotalClaimed: userTotalClaimed,
        isClaiming: isClaiming,
        userTotal: userTotal,
        total: _launchpadConstants_1.ZERO_BN,
        claims: claims,
        availableClaims: [],
        isEligible: true,
        paused: false,
        loaded: loaded,
        address: distribution.claimerAddress,
        chain: distribution.network,
    };
}
exports.useServerClaimer = useServerClaimer;
